<h1 mat-dialog-title
  class="draggable-dialogue-header"
  cdkDrag
  cdkDragRootElement=".cdk-overlay-pane"
  cdkDragHandle>
  Export Site
</h1>

<form>
  <div mat-dialog-content>
    <p [ngClass]="!this.JobInitiated ? 'active-p' : 'idle-p'">Site '{{this.ExportSiteName}}' will be exported as a .zip file.</p>
  </div>

  <div class="export-structure-only-checkbox">
    <mat-checkbox name="ExportStructureOnly" [(ngModel)]="ExportStructureOnly">Export Site Structure Only (no Data)?</mat-checkbox>
  </div>

  <div class="execution-time-div">
    <span>Execution Time:</span>
    <span [ngClass]="this.JobInProgress ? 'active-execution-time-span' : 'idle-execution-time-span'">{{this.JobTimeElapsed}}</span>
  </div>

  <div class="execution-status-div">
    <span>Execution Status:</span>
    <span [ngClass]="this.JobCompleted ? 'completed-execution-status-span' : 'incomplete-execution-status-span'">{{this.ExportStatus}}</span>
  </div>

  <div class="execution-summary-div">
    <p [ngClass]="this.JobErrorOccurred ? 'execution-summary-p execution-summary-with-error-p' : 'execution-summary-p execution-summary-without-error-p'"
    data-placeholder="Details will display here ...">{{this.ExecutionSummaryText}}</p>
  </div>

  <div mat-dialog-actions>
    <button mat-flat-button
      type="submit"
      color="primary"
      class="theme-primary-btn"
      [disabled]="this.JobInitiated"
      (click)="this.startSiteExport()">
      Start Export ...
    </button>
    <button mat-flat-button
      type="submit"
      color="accent"
      [disabled]="!this.JobInitiated"
      [mat-dialog-close]="this.DownloadExportedSiteUrl">
      Dismiss
    </button>

    <ng-container>
      @if (this.DownloadExportedSiteUrl != null) {
        <a
          href="{{this.DownloadExportedSiteUrl}}"
          target="_blank"
        class="download-a">Download</a>
      }
      @if (this.DownloadExportedSiteUrl == null) {
        <span
        class="download-span">Download</span>
      }
    </ng-container>

    <button mat-stroked-button
      [disabled]="this.JobInitiated"
      [mat-dialog-close]="null"
      color="basic"
      style="margin-left: 10px;">
      Cancel
    </button>
  </div>
</form>
